import React from "react";

import UnitFilters from "AppComponents/LEIntoUnitImport/components/UnitFilters";
import UnitFeed from "AppComponents/LEIntoUnitImport/components/UnitFeed";
import classes from "./UnitSelectionPage.scss";

function UnitSelectionPage(props) {
  const { academicYears } = props;

  return (
    <div className={classes.container}>
      <UnitFilters academicYears={academicYears} />
      <UnitFeed academicYears={academicYears} />
    </div>
  );
}

export default UnitSelectionPage;
